import styled from "styled-components";

export const Sticky = styled.div`
  position: sticky;
  z-index: 9;
  top: 2.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  padding-bottom: ${({ sticky, theme }) => (sticky ? theme.space.md : 0)};
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    top: 4rem;
    padding-bottom: ${({ sticky, theme }) => (sticky ? theme.space.lg : 0)};
  }

  > :first-child {
    margin-bottom: 1rem;
  }

  ${(props) =>
    props.sticky &&
    `box-shadow: 0 3px 2px -2px rgba(0, 0, 0, .14),
    0 3px 2px -2px rgba(0, 0, 0, .12), 0 3px 3px -2px rgba(0, 0, 0, .2);
  `};
`;
